<template>
  <div class="page-info" v-scroll-spy="scrollPos">

    <top-subpage-section>
      <page-header :title="`Signup &amp; ${year} Teams`">
        <div class="columns is-gapless is-flex-mobile has-text-centered" :class="[{ 'is-centered': !isDesktop }]">
          <div class="column" v-if="isDesktop">&nbsp;<!-- stub --></div>
          <div class="column is-narrow subnav-item">
            <a href="#" @click="$event.preventDefault();onScrollTo('info','info-sign-up')">
              <img src="../assets/ic_info.svg" width=80 style="width:80px;" /><br />
              <h4 class="text">
                Signup
              </h4>
            </a>
          </div>
          <div class="column is-narrow subnav-item">
            <a href="#" @click="$event.preventDefault();onScrollTo('info','info-prize')">
              <img src="../assets/ic_prize.svg" width=80 style="width:80px;" /><br />
              <h4 class="text">
                Prize
              </h4>
            </a>
          </div>
          <div class="column is-narrow subnav-item">
            <a href="#" @click="$event.preventDefault();onScrollTo('teams','info-teams')">
              <img src="../assets/ic_team.svg" width=80 style="width:80px;" /><br />
              <h4 class="text">
                {{ year }} Teams
              </h4>
            </a>
          </div>
        </div>
      </page-header>
    </top-subpage-section>

    <div class="page-content-bg">

      <about-sign-up-sub-section id="info-sign-up"></about-sign-up-sub-section>

      <about-prize-sub-section id="info-prize" name="bosshog::about-prize" is-alt="true"></about-prize-sub-section>

      <about-prize-awards-sub-section id="info-prize-awards"
        :name-like="['bosshog::about-prize-award']">
      </about-prize-awards-sub-section>

      <!-- <teams-sub-section id="info-teams" title="Teams"></teams-sub-section> -->

    </div>

    <vm-back-top :bottom="45" :right="25" :duration="1000" :timing="'ease'" v-if="false">
      <div class="top"><span></span></div>
    </vm-back-top>
  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
import PageHeader from '@/components/PageHeader'
import PageSubheader from '@/components/PageSubheader'
import TopSubpageSection from '@/components/TopSubpageSection'
import AboutSubSection from './AboutSubSection'
import AboutSignUpSubSection from './AboutSignUpSubSection'
import AboutPrizeSubSection from './AboutPrizeSubSection'
import AboutPrizeAwardsSubSection from './AboutPrizeAwardsSubSection'
// import TeamsSubSection from '@/components/TeamsSubSection'

export default {
  name: 'page-info',
  components: {
    DivContainer,
    PageHeader,
    PageSubheader,
    TopSubpageSection,
    AboutSubSection,
    AboutSignUpSubSection,
    AboutPrizeSubSection,
    AboutPrizeAwardsSubSection
    // TeamsSubSection
  },
  data () {
    return {
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0
    }
  },
  computed: {
    year: function () {
      return EventBus.info.year
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor)
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor)
      }.bind(this), 1000)
    }

    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: 0 })
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-info {
  position: relative;
  background-color: $color-beige;

  .page-content-bg {
    // background-image: url(../assets/menubg.jpg);
    // background-repeat: no-repeat;
    // background-position: top;
  }
}

</style>



// WEBPACK FOOTER //
// Info.vue?3d2a00e7